export default "__VITE_ASSET__C7MDH0TK__"